import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import { changeDeptApi } from '@/api/baseApp/user';
import router, { resetRouter } from '@/router';
import Hamburger from '@/components/Hamburger';
import store from '@/store';
import { removeJsTopic } from '@/utils/auth';
export default {
  components: {
    Hamburger: Hamburger
  },
  data: function data() {
    return {
      nowTime: moment().format('HH:mm:ss'),
      newTime: moment().format('YYYY:MM:DD'),
      isClass: '',
      routerList: ['energyManagement', 'management', 'energyAlarm', 'consumptionanalysis', 'buildingEnergy', 'diagnosisEnergySaving', 'energyMonitoring'],
      deptList: [{
        id: '4cdbb635-3325-4890-9c97-5e20614b2077',
        orgName: '上海体育场'
      }],
      deptId: '4cdbb635-3325-4890-9c97-5e20614b2077'
      // '6ed4cf04-5918-4cc1-8184-8b03ee42f084' //节能诊断
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar',
  // 'deptList',
  // 'deptId',
  'routeList', 'addRoutes'])), mapState({
    isPower: function isPower(state) {
      return state.settings.isPower;
    }
  })),
  watch: {
    $route: {
      handler: function handler(route) {
        var path = route.matched[0].path;
        this.isClass = path;
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;
    // this.isClass = this.$route.path
    console.log(this.deptList, 'deptList');
    setInterval(function () {
      _this.nowTime = moment().format('HH:mm:ss');
    }, 1000);
  },
  mounted: function mounted() {
    var _this2 = this;
    var routerList = this.routerList.filter(function (item) {
      return _this2.routeList.includes('/' + item);
    });
    // console.log('his.routeList.routeList', routerList)
    this.routerList = routerList;
  },
  methods: {
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              // window.location.replace('https://10.106.46.199:8443/apphub/')
              window.open('', '_self', '');
              window.close();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    deptChange: function () {
      var _deptChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val) {
        var _this3 = this;
        var loading, _yield$store$dispatch, roleId, url, accessRoutes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '身份切换中请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // const shrName = this.deptList.find(item => item.id === val)
              // const orgList = {
              //   shrName: shrName.orgName,
              //   orgId: val
              // }
              // console.log(orgList)
              _context3.next = 3;
              return changeDeptApi({
                deptId: val
              });
            case 3:
              _context3.next = 5;
              return store.dispatch('user/getInfo');
            case 5:
              _yield$store$dispatch = _context3.sent;
              roleId = _yield$store$dispatch.roleId;
              url = process.env.VUE_APP_BASE_API;
              if (!(url !== 'https://kepler-xbox.dlg-tec.com' || url !== 'https://alphafm.dlg-property.com')) {
                _context3.next = 11;
                break;
              }
              _context3.next = 11;
              return store.dispatch('user/jsGetTopic').catch(function (error) {
                removeJsTopic();
                console.log(error);
              });
            case 11:
              _context3.next = 13;
              return store.dispatch('permission/generateRoutes', roleId);
            case 13:
              accessRoutes = _context3.sent;
              console.log(accessRoutes);
              setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return store.dispatch('baseApp/getUserApplication');
                    case 2:
                      // await store.dispatch('user/getDataByOrgIdAndShrName', orgList)
                      _this3.$router.push({
                        path: '/dashboard'
                      });
                      _context2.next = 5;
                      return store.dispatch('tagsView/delAllViews', null, {
                        root: true
                      });
                    case 5:
                      // 重置路由
                      resetRouter();
                      // dynamically add accessible routes
                      router.addRoutes(accessRoutes);
                      loading.close();
                    case 8:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })), 1000);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deptChange(_x) {
        return _deptChange.apply(this, arguments);
      }
      return deptChange;
    }(),
    handelRouter: function handelRouter(router) {
      var routers = this.addRoutes.filter(function (item) {
        return router === item.path;
      });
      this.$router.push(router + '/' + routers[0].children[0].path);
      this.isClass = router;
    } // getLabel(label) {
    //   var index = label.lastIndexOf('\/')
    //   return label.substring(index + 1, label.length)
    // }
  }
};